import { useMemo } from 'react';
import noop from 'lodash/noop';

import { MIN_RADIUS_ZOOM_LEVEL } from 'Components/shared/GoogleMap/GoogleMap.consts';

import { getSellerLocation, isMaxZoomLevel } from '../SwitchableMap.helpers';

import { CIRCLE_OPTIONS } from './DynamicMap.consts';
import type { OnZoomChangedProps, UseDynamicMapBounds } from './DynamicMap.types';

let areaCircle = {
	setMap: noop,
};

export const onZoomChanged = ({ Circle, location, map }: OnZoomChangedProps): void => {
	const zoomLevel = map.getZoom();
	if (!zoomLevel) {
		areaCircle.setMap(null);
		return;
	}

	if (zoomLevel >= MIN_RADIUS_ZOOM_LEVEL) {
		const centerLocation = new google.maps.LatLng(location.lat ?? 0, location.lng ?? 0);
		areaCircle.setMap(null);
		areaCircle = new Circle({ center: centerLocation, map, ...CIRCLE_OPTIONS });
	}
};

export const useDynamicMapBounds: UseDynamicMapBounds = ({ distance, isDealerMarkerVisible, locations }) => {
	const { dealer, seller } = locations;
	const sellerLocation = getSellerLocation(seller);

	return useMemo<google.maps.LatLngBoundsLiteral>(() => {
		const sellerLocationBounds = {
			east: sellerLocation?.lng ?? 0,
			north: sellerLocation?.lat ?? 0,
			south: sellerLocation?.lat ?? 0,
			west: sellerLocation?.lng ?? 0,
		};

		if (!isDealerMarkerVisible) {
			return sellerLocationBounds;
		}

		if (dealer.latitude && dealer.longitude && sellerLocation?.lat && sellerLocation.lng) {
			return {
				east: Math.max(dealer.longitude, sellerLocation.lng),
				north: Math.max(dealer.latitude, sellerLocation.lat),
				...(isMaxZoomLevel(distance) ? { padding: 0 } : {}),
				south: Math.min(dealer.latitude, sellerLocation.lat),
				west: Math.min(dealer.longitude, sellerLocation.lng),
			};
		}

		return sellerLocationBounds;
	}, [isDealerMarkerVisible, dealer.latitude, dealer.longitude, sellerLocation, distance]);
};
